// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProcessBoard_wrapper__3fn7_"};